/* OMNIMUSCLE Food Library
   Per 100g unless serving_size says otherwise.
   Values from USDA FoodData Central / typical product labels.
   Macros: cal=kcal, p=protein g, c=carbs g, f=fat g, fib=fiber g, sug=sugar g, na=sodium mg
*/

const F = (id, name, category, serving, cal, p, c, f, fib = 0, sug = 0, na = 0) => ({
  id,
  name,
  category,
  serving,
  cal,
  p,
  c,
  f,
  fib,
  sug,
  na,
});

export const FOOD_LIBRARY = [
  // ===== PROTEINS =====
  F("chicken-breast", "Chicken Breast (cooked)", "Protein", "100g", 165, 31, 0, 3.6, 0, 0, 74),
  F("chicken-thigh", "Chicken Thigh (cooked, skinless)", "Protein", "100g", 209, 26, 0, 11, 0, 0, 88),
  F("turkey-breast", "Turkey Breast (cooked)", "Protein", "100g", 135, 30, 0, 1, 0, 0, 54),
  F("ground-beef-93", "Ground Beef 93/7 (cooked)", "Protein", "100g", 175, 26, 0, 8, 0, 0, 75),
  F("ground-beef-80", "Ground Beef 80/20 (cooked)", "Protein", "100g", 254, 26, 0, 17, 0, 0, 75),
  F("steak-sirloin", "Sirloin Steak (cooked)", "Protein", "100g", 206, 30, 0, 9, 0, 0, 60),
  F("ground-turkey", "Ground Turkey 93% (cooked)", "Protein", "100g", 176, 27, 0, 8, 0, 0, 80),
  F("salmon", "Salmon (cooked)", "Protein", "100g", 208, 22, 0, 13, 0, 0, 59),
  F("tuna-canned", "Tuna (canned in water)", "Protein", "100g", 116, 26, 0, 1, 0, 0, 247),
  F("cod", "Cod (cooked)", "Protein", "100g", 105, 23, 0, 0.9, 0, 0, 78),
  F("tilapia", "Tilapia (cooked)", "Protein", "100g", 129, 26, 0, 2.7, 0, 0, 56),
  F("shrimp", "Shrimp (cooked)", "Protein", "100g", 99, 24, 0.2, 0.3, 0, 0, 111),
  F("egg-whole", "Whole Egg (large)", "Protein", "1 egg (50g)", 72, 6.3, 0.4, 4.8, 0, 0.2, 71),
  F("egg-white", "Egg White (large)", "Protein", "1 white (33g)", 17, 3.6, 0.2, 0.1, 0, 0.2, 55),
  F("greek-yogurt-0", "Greek Yogurt (0% fat, plain)", "Protein", "170g cup", 100, 17, 6, 0.7, 0, 6, 65),
  F("cottage-cheese-1", "Cottage Cheese (1% fat)", "Protein", "100g", 72, 12, 2.7, 1, 0, 2.7, 406),
  F("whey-isolate", "Whey Isolate Scoop", "Protein", "1 scoop (30g)", 110, 25, 2, 0.5, 0, 1, 90),
  F("casein", "Casein Protein Scoop", "Protein", "1 scoop (33g)", 120, 24, 4, 1, 1, 1, 130),
  F("tofu-firm", "Tofu (firm)", "Protein", "100g", 144, 17, 3, 9, 2, 0.6, 14),
  F("tempeh", "Tempeh", "Protein", "100g", 192, 20, 8, 11, 0, 0, 9),
  F("seitan", "Seitan", "Protein", "100g", 370, 75, 14, 1.9, 0, 0, 29),
  F("bacon", "Bacon (cooked)", "Protein", "1 slice (8g)", 43, 3, 0.1, 3.3, 0, 0, 185),
  F("pork-tenderloin", "Pork Tenderloin (cooked)", "Protein", "100g", 143, 26, 0, 3.5, 0, 0, 48),
  F("deli-turkey", "Deli Turkey", "Protein", "2 slices (56g)", 50, 9, 1, 1, 0, 1, 460),

  // ===== CARBS / GRAINS =====
  F("rice-white", "White Rice (cooked)", "Carb", "100g", 130, 2.7, 28, 0.3, 0.4, 0, 1),
  F("rice-brown", "Brown Rice (cooked)", "Carb", "100g", 112, 2.6, 24, 0.9, 1.8, 0.4, 5),
  F("rice-jasmine", "Jasmine Rice (cooked)", "Carb", "100g", 129, 2.7, 28, 0.3, 0.4, 0, 1),
  F("oats", "Rolled Oats (dry)", "Carb", "1/2 cup (40g)", 150, 5, 27, 2.5, 4, 1, 0),
  F("quinoa", "Quinoa (cooked)", "Carb", "100g", 120, 4.4, 21, 1.9, 2.8, 0.9, 7),
  F("pasta-cooked", "Pasta (cooked, white)", "Carb", "100g", 158, 5.8, 31, 0.9, 1.8, 0.6, 1),
  F("whole-wheat-pasta", "Whole Wheat Pasta (cooked)", "Carb", "100g", 124, 5, 27, 0.5, 4, 1, 4),
  F("bread-white", "White Bread", "Carb", "1 slice (28g)", 75, 2.5, 14, 1, 0.7, 1.4, 142),
  F("bread-whole-wheat", "Whole Wheat Bread", "Carb", "1 slice (28g)", 70, 4, 12, 1, 2, 2, 130),
  F("bagel", "Plain Bagel", "Carb", "1 (105g)", 277, 11, 56, 1.5, 2.4, 6, 530),
  F("tortilla-flour", "Flour Tortilla (10in)", "Carb", "1 tortilla", 218, 6, 36, 5, 2, 1, 391),
  F("tortilla-corn", "Corn Tortilla (6in)", "Carb", "1 tortilla", 50, 1.4, 11, 0.5, 1.5, 0.2, 11),
  F("potato", "Potato (baked, w/ skin)", "Carb", "1 medium (173g)", 161, 4.3, 37, 0.2, 3.8, 1.7, 17),
  F("sweet-potato", "Sweet Potato (baked)", "Carb", "100g", 90, 2, 21, 0.2, 3.3, 6.5, 36),
  F("white-rice-cup", "White Rice (1 cup)", "Carb", "1 cup (158g)", 205, 4.3, 45, 0.4, 0.6, 0, 2),
  F("english-muffin", "English Muffin", "Carb", "1 (57g)", 134, 4.4, 26, 1, 1.5, 1.3, 264),
  F("cereal-cheerios", "Cheerios", "Carb", "1 cup (28g)", 100, 3, 20, 2, 3, 1, 140),
  F("granola", "Granola", "Carb", "1/2 cup (55g)", 230, 6, 32, 9, 4, 12, 50),

  // ===== VEGETABLES =====
  F("broccoli", "Broccoli (cooked)", "Vegetable", "100g", 35, 2.4, 7.2, 0.4, 3.3, 1.4, 41),
  F("spinach-raw", "Spinach (raw)", "Vegetable", "100g", 23, 2.9, 3.6, 0.4, 2.2, 0.4, 79),
  F("kale-raw", "Kale (raw)", "Vegetable", "100g", 49, 4.3, 9, 0.9, 3.6, 2.3, 38),
  F("carrots", "Carrots (raw)", "Vegetable", "100g", 41, 0.9, 9.6, 0.2, 2.8, 4.7, 69),
  F("bell-pepper", "Bell Pepper", "Vegetable", "100g", 31, 1, 6, 0.3, 2.1, 4.2, 4),
  F("asparagus", "Asparagus (cooked)", "Vegetable", "100g", 22, 2.4, 4.1, 0.2, 2, 1.3, 14),
  F("brussels-sprouts", "Brussels Sprouts (cooked)", "Vegetable", "100g", 36, 2.6, 7, 0.5, 2.6, 1.7, 21),
  F("cauliflower", "Cauliflower (cooked)", "Vegetable", "100g", 23, 1.8, 4, 0.5, 2.3, 1.7, 15),
  F("zucchini", "Zucchini (cooked)", "Vegetable", "100g", 17, 1.2, 3, 0.4, 1, 2.5, 8),
  F("tomato", "Tomato", "Vegetable", "1 medium (123g)", 22, 1.1, 4.8, 0.2, 1.5, 3.2, 6),
  F("cucumber", "Cucumber", "Vegetable", "100g", 16, 0.7, 3.6, 0.1, 0.5, 1.7, 2),
  F("mushrooms", "Mushrooms (cooked)", "Vegetable", "100g", 28, 2.2, 5.3, 0.5, 2.2, 2, 6),
  F("onion", "Onion (raw)", "Vegetable", "100g", 40, 1.1, 9.3, 0.1, 1.7, 4.2, 4),
  F("avocado", "Avocado", "Vegetable", "1/2 medium (100g)", 160, 2, 8.5, 14.7, 6.7, 0.7, 7),
  F("salad-mixed", "Mixed Greens", "Vegetable", "1 cup (60g)", 9, 0.7, 1.6, 0.1, 0.9, 0.5, 8),

  // ===== FRUITS =====
  F("banana", "Banana", "Fruit", "1 medium (118g)", 105, 1.3, 27, 0.4, 3.1, 14, 1),
  F("apple", "Apple", "Fruit", "1 medium (182g)", 95, 0.5, 25, 0.3, 4.4, 19, 2),
  F("strawberries", "Strawberries", "Fruit", "100g", 32, 0.7, 7.7, 0.3, 2, 4.9, 1),
  F("blueberries", "Blueberries", "Fruit", "100g", 57, 0.7, 14, 0.3, 2.4, 10, 1),
  F("orange", "Orange", "Fruit", "1 medium (131g)", 62, 1.2, 15, 0.2, 3.1, 12, 0),
  F("grapes", "Grapes", "Fruit", "100g", 69, 0.7, 18, 0.2, 0.9, 16, 2),
  F("watermelon", "Watermelon", "Fruit", "100g", 30, 0.6, 7.6, 0.2, 0.4, 6.2, 1),
  F("pineapple", "Pineapple", "Fruit", "100g", 50, 0.5, 13, 0.1, 1.4, 9.9, 1),
  F("mango", "Mango", "Fruit", "100g", 60, 0.8, 15, 0.4, 1.6, 14, 1),
  F("raspberries", "Raspberries", "Fruit", "100g", 52, 1.2, 12, 0.7, 6.5, 4.4, 1),
  F("kiwi", "Kiwi", "Fruit", "1 medium (76g)", 42, 0.8, 10, 0.4, 2.1, 6.7, 2),

  // ===== DAIRY =====
  F("milk-skim", "Skim Milk", "Dairy", "1 cup (245g)", 83, 8, 12, 0.2, 0, 12, 103),
  F("milk-2", "2% Milk", "Dairy", "1 cup (244g)", 122, 8, 12, 4.8, 0, 12, 115),
  F("milk-whole", "Whole Milk", "Dairy", "1 cup (244g)", 149, 8, 12, 8, 0, 12, 105),
  F("almond-milk", "Almond Milk (unsweetened)", "Dairy", "1 cup (240g)", 30, 1, 1, 2.5, 1, 0, 170),
  F("cheddar", "Cheddar Cheese", "Dairy", "28g slice", 113, 7, 0.4, 9.3, 0, 0.1, 174),
  F("mozzarella-low", "Mozzarella (part-skim)", "Dairy", "28g", 71, 7, 0.8, 4.5, 0, 0.3, 175),
  F("string-cheese", "String Cheese", "Dairy", "1 stick (28g)", 80, 6, 1, 6, 0, 0, 200),
  F("butter", "Butter", "Dairy", "1 tbsp (14g)", 102, 0.1, 0, 11.5, 0, 0, 91),

  // ===== FATS / NUTS =====
  F("almonds", "Almonds", "Fat", "28g (~23 nuts)", 164, 6, 6, 14, 3.5, 1.2, 0),
  F("peanut-butter", "Peanut Butter (natural)", "Fat", "2 tbsp (32g)", 188, 8, 6, 16, 2, 3, 0),
  F("walnuts", "Walnuts", "Fat", "28g", 185, 4.3, 3.9, 18.5, 1.9, 0.7, 1),
  F("cashews", "Cashews", "Fat", "28g", 157, 5.2, 8.6, 12.4, 0.9, 1.7, 3),
  F("pistachios", "Pistachios", "Fat", "28g", 159, 5.7, 7.7, 12.8, 3, 2.2, 0),
  F("olive-oil", "Olive Oil", "Fat", "1 tbsp (14g)", 119, 0, 0, 13.5, 0, 0, 0),
  F("coconut-oil", "Coconut Oil", "Fat", "1 tbsp (14g)", 117, 0, 0, 13.6, 0, 0, 0),
  F("chia-seeds", "Chia Seeds", "Fat", "28g", 138, 4.7, 12, 8.7, 9.8, 0, 5),
  F("flax-seeds", "Ground Flax Seeds", "Fat", "1 tbsp (10g)", 55, 2, 3, 4.3, 2.8, 0.2, 3),

  // ===== LEGUMES =====
  F("black-beans", "Black Beans (cooked)", "Legume", "100g", 132, 8.9, 24, 0.5, 8.7, 0.3, 1),
  F("kidney-beans", "Kidney Beans (cooked)", "Legume", "100g", 127, 8.7, 23, 0.5, 6.4, 0.3, 1),
  F("chickpeas", "Chickpeas (cooked)", "Legume", "100g", 164, 8.9, 27, 2.6, 7.6, 4.8, 7),
  F("lentils", "Lentils (cooked)", "Legume", "100g", 116, 9, 20, 0.4, 7.9, 1.8, 2),
  F("hummus", "Hummus", "Legume", "2 tbsp (30g)", 70, 2, 6, 5, 1.5, 0, 130),
  F("edamame", "Edamame (shelled)", "Legume", "100g", 121, 12, 9, 5, 5, 2.2, 6),

  // ===== SUPPLEMENTS / RTD =====
  F("creatine", "Creatine Monohydrate", "Supplement", "5g", 0, 0, 0, 0, 0, 0, 0),
  F("bcaa-scoop", "BCAA Scoop", "Supplement", "1 scoop (10g)", 30, 7, 0, 0, 0, 0, 60),
  F("preworkout", "Pre-Workout Scoop", "Supplement", "1 scoop", 5, 0, 1, 0, 0, 0, 100),
  F("whey-rtd", "Whey RTD Shake", "Supplement", "1 bottle (325ml)", 160, 30, 5, 3, 1, 2, 200),
  F("mass-gainer", "Mass Gainer Scoop", "Supplement", "2 scoops (300g)", 1100, 50, 200, 8, 4, 30, 400),

  // ===== SNACKS / MISC =====
  F("rice-cake", "Rice Cake (plain)", "Snack", "1 cake (9g)", 35, 0.7, 7.3, 0.3, 0.4, 0.1, 0),
  F("dark-chocolate", "Dark Chocolate (70%)", "Snack", "28g", 168, 2, 13, 12, 3, 7, 6),
  F("protein-bar", "Protein Bar (avg)", "Snack", "1 bar (60g)", 220, 20, 22, 7, 4, 8, 200),
  F("granola-bar", "Granola Bar", "Snack", "1 bar (24g)", 100, 2, 17, 3.5, 1, 7, 80),
  F("popcorn-air", "Air-Popped Popcorn", "Snack", "1 cup (8g)", 31, 1, 6.2, 0.4, 1.2, 0.1, 1),
  F("beef-jerky", "Beef Jerky", "Snack", "28g", 116, 9, 3, 7, 0.5, 2.5, 506),
  F("trail-mix", "Trail Mix", "Snack", "28g", 131, 4, 12, 8, 1.5, 7, 65),

  // ===== BEVERAGES =====
  F("water", "Water", "Beverage", "8oz (240ml)", 0, 0, 0, 0, 0, 0, 0),
  F("black-coffee", "Black Coffee", "Beverage", "8oz (240ml)", 2, 0.3, 0, 0, 0, 0, 5),
  F("green-tea", "Green Tea", "Beverage", "8oz (240ml)", 2, 0, 0.5, 0, 0, 0, 2),
  F("orange-juice", "Orange Juice", "Beverage", "1 cup (248g)", 112, 1.7, 26, 0.5, 0.5, 21, 2),
  F("gatorade", "Gatorade", "Beverage", "20oz (600ml)", 140, 0, 36, 0, 0, 34, 270),
  F("diet-soda", "Diet Soda", "Beverage", "12oz can", 0, 0, 0, 0, 0, 0, 40),
  F("almond-milk-vanilla", "Almond Milk (vanilla, unsweet)", "Beverage", "1 cup (240g)", 30, 1, 1, 2.5, 1, 0, 170),

  // ===== RESTAURANT / FAST FOOD =====
  F("chipotle-bowl", "Chipotle Chicken Bowl (basic)", "Restaurant", "1 bowl", 600, 50, 60, 14, 12, 4, 1300),
  F("subway-turkey", "Subway Turkey 6in", "Restaurant", "1 sub", 280, 18, 46, 3.5, 5, 7, 760),
  F("big-mac", "McDonald's Big Mac", "Restaurant", "1 burger", 590, 25, 46, 34, 3, 9, 1010),
  F("mcd-fries-med", "McDonald's Fries (Medium)", "Restaurant", "111g", 320, 4, 43, 15, 4, 0, 230),
  F("pizza-slice", "Pizza Slice (cheese)", "Restaurant", "1 slice (107g)", 285, 12, 36, 10, 2.5, 4, 640),
  F("starbucks-latte", "Starbucks Latte (grande, 2%)", "Restaurant", "16oz", 190, 12, 18, 7, 0, 18, 170),
];

export const CATEGORIES = [
  "All",
  "Protein",
  "Carb",
  "Vegetable",
  "Fruit",
  "Dairy",
  "Fat",
  "Legume",
  "Supplement",
  "Snack",
  "Beverage",
  "Restaurant",
];
